export const DEFAULT_IMAGE_TYPE = 'Markup';
